import { Component, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-pulses-help-modal',
  templateUrl: './pulses-help-modal.component.pug',
  styleUrls: ['./pulses-help-modal.component.scss'],
  standalone: false
})
export class PulsesHelpModalComponent implements OnInit {

  constructor(
    private modalService: BsModalService,
    private permissions:PermissionsService
  ) {}

  ngOnInit(): void {}

  closeModal(): void {
    this.modalService.hide()
  }

}
